// Core
import { Box, Button, Flex, Text, Divider, Grid, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { NavLink } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { parseFullDate } from 'services/Utils';
import placeholderGiveaways from 'assets/img/placeholder-giveaways.jpg';

// Components
import { StarsIcon } from 'components/Icons/Icons';
import Countdown from 'components/Timers/Countdown';

const LargeScale = () => {
	const { colorMode } = useColorMode();
  	const isDark = colorMode === 'dark';

	const bgDividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
	const bgDividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  	const bgDivider = useColorModeValue(bgDividerWhite, bgDividerDark);
  
	const activeSlide = 0;
    const { data, isLoading } = useQuery({
        queryKey: ['largeScale'],
        queryFn: async () => {
            const response = await apiService.getBanners({ limit: 1, offset: 0, objectType: 'giveaways' });
            return response.data;
        },
        refetchOnWindowFocus: false
    });

	return (
	  	<>
	  		{ !isLoading && data && data[activeSlide] && (
	  			<Grid mt={{ base: '30px', md: '80px'}} alignItems="center" templateColumns={{ sm: '1fr', md: '1fr 1fr' }} gap="16px" templateRows='1fr'>
			    	<Box>
			    		<Box position="relative">
				    		<Box w="fit-content" mt="7px">
					        	<Text as="h2" variant="header-gradient" fontSize={{ base: '48px', md: '48px', lg: '56px'}}>
					        		Large-scale</Text>
					        	<Divider mt="0px" h="2px" bg={bgDivider} borderWidth="0" />
					        </Box>
				    		<Flex gap="14px" mt="9px" alignItems="center">
				    			<StarsIcon fontSize={{ base: '32px', md: '43px'}} />
				    			<Box 
				    				borderRadius="16px"
					        		p={{ base: '2px 16px', md: '4px 24px' }}
					  			    background="white">
				    				<Text variant="header-gradient" fontSize={{ base: '40px', md: '44px', lg: '48px'}}>
				    					Giveaways</Text>
				    			</Box>
				    		</Flex>

				    		{ isDark && <Box className="abstract-grad" left="-10%" transform="scale(0.6)" top={{ base: '80%', md: '10%'}} /> }
			    		</Box>

			    		<Box mt="32px">
			    			<Text variant="header" fontSize={{ base: '36px', md: '48px'}} textTransform="unset">{data[activeSlide]?.title}</Text>
			    			<Text
			    				mt="5px" 
			    				fontSize={{ base: '18px', md: '24px'}}
			    				fontWeight="500"
			    				color="#9FABCB">
			    				{parseFullDate(data[activeSlide]?.date)}</Text>

			    			{ data[activeSlide]?.objectId && (
			    				<NavLink to={`/giveaways/${data[activeSlide]?.objectId}`}>
			    					<Button mt="25px" variant="button-lg-g" maxW={{ base: '100%', md: '280px'}}>Enter Now</Button>
			    				</NavLink>
			    			)}
			    		</Box>
					</Box>

					<Box
						borderRadius="16px"
		        		w="100%"
		        		minH={{ sm: '120px', md: '160px' }}
		        		mt={{ sm: '24px', md: '0' }}
						border="1px solid #2ABDFD"
						overflow="hidden"
						display="flex"
					    alignItems="center"
					    justifyContent="center"
					    position="relative"
						boxShadow={ isDark ? '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)' : 'unset'} >
						<Image 
							src={data[activeSlide]?.image ?? placeholderGiveaways} 
							fallbackSrc={placeholderGiveaways}
							alt="Large Scale Giveaways"
							display="block"
							w="100%"
							h="auto" />
	        			<Countdown 
	        				fontSize={{sm: '20px', md: '24px', lg: '32px'}} 
	        				declareDate={data[activeSlide]?.date} />
					</Box>
				</Grid>
			)}
		</>
	);
};

export default LargeScale;